module.exports = __webpack_public_path__ + "black2.a71bd9d7.jpg";